import { Component, OnInit, HostListener } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { CmsmoduleService } from 'src/app/manage/cmsmodule/service/cmsmodule.service';
import { BannerService } from 'src/app/services/banner.service';
import { TeamService } from 'src/app/services/team.service';
import {
  SwiperComponent,
  SwiperDirective,
  SwiperConfigInterface,
  SwiperScrollbarInterface,
  SwiperPaginationInterface
} from 'ngx-swiper-wrapper';
import { ActivatedRoute, Router } from '@angular/router';
import { TeamMembersService } from 'src/app/services/teamMembers.service';
import { TeamImageService } from 'src/app/services/teamImage.service';
import { TeamVideoService } from 'src/app/services/teamVideo.service';
import { TeamSponsorsService } from 'src/app/services/teamSponsors.service';
import { DomSanitizer } from "@angular/platform-browser";
@Component({
  selector: 'app-team-details',
  templateUrl: './team-details.component.html',
  styleUrls: ['./team-details.component.scss']
})

export class TeamDetailsComponent implements OnInit {
  availableClasses: string[] = ["bg-white", "light", "colorful"];
  currentClassIdx: number = 0;
  bodyClass: string;
  public owners_config: SwiperConfigInterface = {
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',
    speed: 400,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
        pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: true,
         touchRatio: 1,
         touchStartPreventDefault: false,
         autoplay: {
          delay: 2000,
          disableOnInteraction: true,
         
        },
      },
      992: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      1199: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      1200: {
        slidesPerView: 2,
        spaceBetween: 30
      }
    }
  };
  public players_config: SwiperConfigInterface = {
    direction: 'horizontal',
    grabCursor: true,
    centeredSlides: false,
    effect: 'slide',
    speed: 400,
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
        pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 15,
        allowTouchMove: true,
         touchRatio: 1,
         touchStartPreventDefault: false,
         autoplay: {
          delay: 2000,
          disableOnInteraction: true,
         
        },
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: true,
         touchRatio: 1,
         touchStartPreventDefault: false,
         autoplay: {
          delay: 2000,
          disableOnInteraction: true,
         
        },
      },
      992: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      1199: {
        slidesPerView: 2,
        spaceBetween: 30
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30
      }
    }
  };
  
  responsiveOptions: any[] = [
    {
      breakpoint: '1500px',
      numVisible: 5
    },
    {
      breakpoint: '1024px',
      numVisible: 3
    },
    {
      breakpoint: '768px',
      numVisible: 2
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  public id;
  public errorMessage: any;
  public teamDetails;
  public teamMemberList: any[] = [];
  public ownerMentorList: any[] = [];
  public playerList: any[] = [];
  public teamImageList: any[] = [];
  public teamImagesArray: any[] = [];
  public teamVideoList: any[] = [];
  public teamSponsorsList: any[] = [];
  public titleSponsorsList: any[] = [];
  public principalSponsorsList: any[] = [];
  public otherSponsorsList: any[] = [];
  public ourPartnerSponsorsList: any[] = [];
  displayBasic: boolean | undefined;
  public showHighlightImg = "";
  public slug;
  highlight:any;
  contentWindow:any;
  constructor(
    private cmsmoduleService: CmsmoduleService,
    private bannerService: BannerService,
    private teamService: TeamService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private teamMembersService: TeamMembersService,
    private teamImageService: TeamImageService,
    private teamVideoService: TeamVideoService,
    private teamSponsorsService: TeamSponsorsService,
    private sanitizer: DomSanitizer
  ) {
    this.bodyClass = this.availableClasses[this.currentClassIdx];
    this.changeBodyClass();
  }
  changeBodyClass() {
    // get html body element
    const bodyElement = document.body;

    if (bodyElement) {


      this.currentClassIdx = this.getNextClassIdx();
      const nextClass = this.availableClasses[this.currentClassIdx];
      const activeClass = this.availableClasses[this.getPrevClassIdx()];

      // remove existing class (needed if theme is being changed)
      bodyElement.classList.remove(activeClass);
      // add next theme class
      bodyElement.classList.add(nextClass);

      this.bodyClass = nextClass;
    }
  }

  getPrevClassIdx(): number {
    return this.currentClassIdx === 0
      ? this.availableClasses.length - 1
      : this.currentClassIdx - 1;
  }

  getNextClassIdx(): number {
    return this.currentClassIdx === this.availableClasses.length - 1
      ? 0
      : this.currentClassIdx + 1;
  }
  ngOnInit(): void {
    this.slug = this.activatedRoute.snapshot.params.slug;
    this.getTeamDetails();
  }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      url + "?controls=0&showinfo=0&rel=0&autoplay=1&loop=0&mute=1"
    );
  }
  getTeamDetails() {
    let query = "?filterByDisable=false&filterByStatus=true&filterBySlug=" + this.slug;
    this.teamDetails = [];
    this.teamService.getTeamListWithoutAuth(query).subscribe(
      data => {
        this.teamDetails = data.data.items[0];
        console.log("team--url--",this.teamDetails)
        this.id = this.teamDetails.id;
        this.getTeamMembers();
        this.getTeamImages();
        this.getTeamVideos();
        this.getTeamSponsors();
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  getTeamMembers() {
    let query = "?filterByDisable=false&filterByStatus=true&filterByTeamId=" + this.id;
    this.teamMembersService.getTeamMembersListWithoutAuth(query).subscribe(
      data => {
        if (data.data.items.length > 0) {
          this.teamMemberList = data.data.items;
          if (this.teamMemberList.length > 0) {
            this.teamMemberList.forEach(element => {

              if (element.memberType == 'co-owner' || element.memberType == 'owner') {
                this.ownerMentorList.push(element);
              }
              setTimeout(() => {
                if (element.memberType == 'brand-ambassador') {
                  this.ownerMentorList.push(element);
                }
              }, 250);
              setTimeout(() => {
                if (element.memberType == 'mentor') {
                  this.ownerMentorList.push(element);
                }
              }, 300);
              if (element.memberType == 'player') {
                this.playerList.push(element);
              }
            })
          }
        }
        console.log(this.ownerMentorList);
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }

  getTeamImages() {
    let query = "?filterByDisable=false&filterByStatus=true&filterByTeamId=" + this.id;
    this.teamImageService.getTeamImageListWithoutAuth(query).subscribe(
      data => {
        this.teamImageList = data.data.items;
        if (this.teamImageList.length > 0) {
          this.teamImagesArray = this.teamImageList[0].team_images;
          console.log("teamImagesArray----",this.teamImagesArray)
        }
      },
      err => {

      }
    )
  }
  getTeamVideos() {
    let query = "?filterByDisable=false&filterByStatus=true&filterByTeamId=" + this.id;
    this.teamVideoService.getTeamVideoListWithoutAuth(query).subscribe(
      data => {
        this.teamVideoList = data.data.items;
        console.log("this.teamVideoList",this.teamVideoList)
      },
      err => {

      }
    )
  }
  getTeamSponsors() {
    let query = "?filterByDisable=false&filterByStatus=true&filterByTeamId=" + this.id;
    this.teamSponsorsService.getTeamSponsorsListWithoutAuth(query).subscribe(
      data => {
        this.teamSponsorsList = data.data.items;
        if (this.teamSponsorsList.length > 0) {
          this.teamSponsorsList.forEach(element => {
            if (element.slug == 'title_sponsors') {
              this.titleSponsorsList.push(element);
            }
            if (element.slug == 'principal_sponsors') {
              this.principalSponsorsList.push(element);
            }
            if (element.slug == 'other_sponsors') {
              this.otherSponsorsList.push(element);
            }
            if (element.slug == 'our_sponsors') {
              this.ourPartnerSponsorsList.push(element);
            }
          })
        }
      },
      err => {

      }
    )
  }
 public openHightlightImage(highlight) {
    console.log("hdhdhdhdh")
    this.displayBasic = true
    this.showHighlightImg = highlight.image_src;
    console.log("displayImage--",this.showHighlightImg)
   
  }

  @HostListener('window:keyup.esc', ['$event']) w(e: KeyboardEvent) {
    this.displayBasic = false;
  }
}
